import React from "react"
import { isMobileResolution } from "@utils/WindowWidth"
import iconMobileSettings from "../../assets/images/tune_24px.svg"

export const MobileMenuIcon = ({
  mobileMenuAnchorEl,
  handleOpenMobileMenu,
}) => {
  if (isMobileResolution())
    return (
      <div
        className={`size-40 w-[40px] h-[40px] flex grow items-center flex-row justify-end`}
      >
        <div
          className={`size-40 w-[40px] h-[40px] ${
            mobileMenuAnchorEl ? `bg-slate-300` : `bg-transparent`
          } flex items-center flex-row justify-center`}
          onClick={handleOpenMobileMenu}
        >
          <img
            src={iconMobileSettings}
            alt="Mobile settings"
            className={`pt-1  md:pt-0`}
          />
        </div>
      </div>
    )
  else return null
}
